import React, { useEffect, useRef, useState } from "react";

import moment from "moment";
import { DialogWrapMedium } from "../../../../controls/components/dialogWrap/DialogWrap";
import {
	PartnerInnerContent,
	PartnerInnerName,
	PartnerInnerNameWWrap,
	UserFormServiceButtonClose,
} from "../../styled/DesStyled";
import useOrderDetail from "../../hook/useGetOrder";
import { OnepayPaymentMethodLabelMap, OrderMethod, OrderMethodLabelMap, OrderStatus, OrderStatusLabelMap, PriceDetail } from "../../../../../models/Order";
import { ActiveTypeMap } from "../../../../../models/Login";
import { PHONE_COUNTRY_CODE } from "../../../LoginUser/hook/phoneCountryCode";
import { formatOrderCreatedAtForStation } from "../../../../../utils/orderDateDisplay";
import { formatOrderCalendarDate } from "../../../../../utils/orderCalendarDate";
import { formatQuantityWithBagSizes } from "../../../../../utils/bagSizeBreakdown";

export default function DialogInfoBookingAdmin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	OrderId: number;
	reload: () => void;
}) {
	const { orderDetail } = useOrderDetail({ id: props.OrderId.toString(), openDialog: props.openDialog });
	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Chi tiết đơn"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Đóng
					</UserFormServiceButtonClose>
				</>
			}>
			<InputPartnerAdmin orderDetail={orderDetail} />
		</DialogWrapMedium>
	);
}

export function InputPartnerAdmin(props: { orderDetail?: PriceDetail }) {
	return (
		<div>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>ID:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.id || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Email:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.email || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Ngày thuê:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.distanceDay || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Số lượng:</PartnerInnerName>
				<PartnerInnerContent>
					{props.orderDetail?.quantity ? formatQuantityWithBagSizes(props.orderDetail) : "Trống"}
				</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Tổng tiền:</PartnerInnerName>
				<PartnerInnerContent>{Math.round((props.orderDetail?.totalMoney ||0) * 100) / 100}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Số điện thoại:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.phone || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Địa chỉ cơ sở:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.partner?.address || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Tên cơ sở:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.partner?.name || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Loại giao dịch:</PartnerInnerName>
				<PartnerInnerContent>
					{props.orderDetail?.paymentMethodSelect ? (
						props.orderDetail.paymentMethodSelect
					) : (
						props.orderDetail?.paymentMethod === OrderMethod.OnePay ? (
						OnepayPaymentMethodLabelMap.get(props.orderDetail?.subPaymentMethod || 0)
						) : (
						OrderMethodLabelMap.get(props.orderDetail?.paymentMethod || 0)
						)
					)}
					</PartnerInnerContent>

				</PartnerInnerNameWWrap>

			<PartnerInnerNameWWrap>
				<PartnerInnerName>Mã giao dịch OnePay:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.onepayPaymentId || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Mã giao dịch PayPal:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.paypalPaymentId || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Mã giao dịch Stripe:</PartnerInnerName>
				<PartnerInnerContent>{props.orderDetail?.stripePaymentId || "Trống"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Trạng thái:</PartnerInnerName>
				<PartnerInnerContent>{OrderStatusLabelMap.get(props.orderDetail?.status || 0)}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Công cụ chat:</PartnerInnerName>
				<PartnerInnerContent>{ActiveTypeMap.get(Number(props.orderDetail?.customer?.communicationId || 0)) || "--"}</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Đầu số quốc gia:</PartnerInnerName>
				<PartnerInnerContent> {PHONE_COUNTRY_CODE.find((val) => val.dial_code === props.orderDetail?.customer?.phonePrefix)?.name || "Không xác định" } ({props.orderDetail?.customer?.phonePrefix})
			</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Ngàt bắt đầu:</PartnerInnerName>
				<PartnerInnerContent>
					{(props.orderDetail?.timeInString && formatOrderCalendarDate(props.orderDetail?.timeInString)) ||(props.orderDetail?.timeIn && formatOrderCalendarDate(props.orderDetail?.timeIn))  ||
						""}
				</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Ngày kết thúc:</PartnerInnerName>
				<PartnerInnerContent>
					{(props.orderDetail?.timeOutString && formatOrderCalendarDate(props.orderDetail?.timeOutString)) || (props.orderDetail?.timeOut && formatOrderCalendarDate(props.orderDetail?.timeOut))|| ""}
				</PartnerInnerContent>
			</PartnerInnerNameWWrap>
			<PartnerInnerNameWWrap>
				<PartnerInnerName>Ngày tạo đơn:</PartnerInnerName>
				<PartnerInnerContent>
					{formatOrderCreatedAtForStation(props.orderDetail?.createdAt, props.orderDetail?.timeZoneId)}
				</PartnerInnerContent>
			</PartnerInnerNameWWrap>
		</div>
	);
}
